import { render } from "./MainIcon.vue?vue&type=template&id=2ed633b6&scoped=true&ts=true"
import script from "./MainIcon.vue?vue&type=script&lang=ts"
export * from "./MainIcon.vue?vue&type=script&lang=ts"

import "./MainIcon.vue?vue&type=style&index=0&id=2ed633b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed633b6"]])

export default __exports__